import { IAppState } from '../../redux';

export const selectIsAgencyBalanceVisible = (state: IAppState): boolean => {
  return !!state.user.showAgencyBalance;
};
